import React, { useRef, useState } from "react"
import { Portal } from "components"
import styles from "css/Bubble.module.css"
import { motion, AnimatePresence } from 'framer-motion'

const Bubble = ({ children, type }) => {
	const [show, setShow] = useState()
	const [top, setTop] = useState()
	const [left, setLeft] = useState()
	const mark = useRef()
	const onClick = () => {
		const pos = mark.current.getBoundingClientRect()
		setTop(pos.top + window.scrollY + 35)
		setLeft(pos.left - 2)
		setShow(true)
	}

	return (
		<>
			<i ref={mark} className={`${type === "white" ? "icon_question_white" : "icon_question"} ${type === "mark" ? "icon_mark_white" : "icon_question"}`} onClick={onClick} />
			<Balloon show={show} setShow={setShow} top={top} left={left}>
				{children}
			</Balloon>
		</>
	)
}

const Balloon = ({ children, show, setShow, top, left }) => {

	const tri = useRef()

	const variants = {
		hidden: {
			opacity: 0
		},
		show: {
			opacity: 1
		}
	}

	const onClose = () => {
		setShow(false)
	}

	return (
		<Portal>
			<AnimatePresence>
			{show && (
				<motion.div variants={variants} initial="hidden" animate="show" exit="hidden" className={styles.bubble} style={{ top: top }}>
					{children}
					<i className='icon_bubble_close' onClick={onClose}></i>
					<div ref={tri} className={styles.tri} style={{ left: left }} />
				</motion.div>
			)}
			</AnimatePresence>
		</Portal>
	)
}

export default Bubble
